export default {
	methods: {
		async goToProducts() {
			const params = this.$route.query.category
				? { category: this.$route.query.category }
				: {}
			const query = { ...this.$route.query }
			if (query.category) {
				delete query.category

				if (query.productId) {
					delete query.productId
				}

				const routerData = {
					name: 'products-category',
					params,
					query
				}

				await this.$router.push(routerData)

				return
			}

			await this.$router.push({ name: 'products' })
		},

		async goToCheck() {
			const { query, params } = this.$route

			const newQuery = { ...query }

			if (params.category) newQuery.category = params.category

			if (newQuery.eventTicketId) delete newQuery.eventTicketId

			await this.$router.push({
				name: 'check',
				query: newQuery
			})
		},

		async goToProcessing() {
			const { query, params } = this.$route

			if (params.eventTicketId) {
				query.eventTicketId = params.eventTicketId
			}

			await this.$router.push({ name: 'processing', query, params })
		},

		async goToToEventTicketTab(eventTicketId) {
			await this.$router.push({
				name: 'payment-method',
				params: { eventTicketId }
			})
		}
	}
}
